import { SearchConsultationsQueryResponse } from '../../../../../../types/api/endpoints/consultations/searchConsultations.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../../utils/api/endpoints/consultationsEndpoints';
import { SearchConsultationsQuery } from './DashboardConsultationsTable.types';

const SEARCH_CONSULTATIONS_PREFIX = '[searchConsultationsQuery]';

export const SEARCH_CONSULTATIONS_QUERY_KEY = 'SEARCH_CONSULTATIONS';

export const searchConsultationsQuery = async ({ search, params }: SearchConsultationsQuery) => {
  console.log(SEARCH_CONSULTATIONS_PREFIX, `Searching "${search}" in consultations...`);

  const response = await CONSULTATIONS_ENDPOINTS.search(search, params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(SEARCH_CONSULTATIONS_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(SEARCH_CONSULTATIONS_PREFIX, `Searched "${search}" in consultations.`);

  return json as SearchConsultationsQueryResponse;
};
